// extracted by mini-css-extract-plugin
export var modalBody = "DepositModal-module--modalBody--972ee";